import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';

const ACTION_LABELS = {
  created: 'Ticket created',
  assigned: 'Assignment changed',
  status_changed: 'Status changed',
  priority_changed: 'Priority changed',
  due_date_changed: 'Due date changed',
  comment: 'Comment added',
  attachment: 'File uploaded',
};

export default function CrmTicketTimeline({ items = [] }) {
  return (
    <Card className="border-border">
      <CardHeader><CardTitle>Activity Timeline</CardTitle></CardHeader>
      <CardContent>
        {items.length === 0 ? (
          <p className="text-muted-foreground text-sm">No activity yet.</p>
        ) : (
          <ul className="space-y-3 border-l-2 border-blue-200 pl-4">
            {items.map((a) => (
              <li key={a.id} className="relative">
                <span className="absolute -left-[21px] top-1 w-2.5 h-2.5 rounded-full bg-blue-600" />
                <p className="text-sm font-medium">
                  {ACTION_LABELS[a.action] || a.action?.replace(/_/g, ' ')}
                  {a.actor_name ? ` · ${a.actor_name}` : ''}
                </p>
                {(a.old_value || a.new_value) && (
                  <p className="text-sm text-muted-foreground">
                    {a.old_value ? `${a.old_value} → ` : ''}{a.new_value}
                  </p>
                )}
                {a.message && <p className="text-sm text-muted-foreground mt-1">{a.message}</p>}
                <p className="text-xs text-muted-foreground mt-1">{a.created_at}</p>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
